import { shortMonth } from '../../constants/shortMonth'

export const getInstallmentDateAndTypeLabel = (date: Date, typeDescription?: string) => {
  let label

  if (!!typeDescription) {
    label = `${shortMonth[date.getMonth()]?.toUpperCase()} ${date.getFullYear()} • ${typeDescription}`
  } else {
    label = `${shortMonth[date.getMonth()]?.toUpperCase()} ${date.getFullYear()}`
  }

  return label
}
